import { SET_DOCUMENTS, SET_DOCUMENT_READ, SET_UNREAD_DOCUMENTS_PRESENT } from "./documentsActions";

const initialState = {
    documents: [],
    nextPage: "",
    totalDocuments: 0,
    unreadDocumentsPresent: false
};

export const documents = (state = initialState, action) => {
    switch (action.type) {
        case SET_DOCUMENTS: {
            const newState = {
                ...state,
                documents: [...state.documents, ...action.documents].filter(
                    (item, index, self) =>
                        index === self.findIndex(i => i.documentId === item.documentId)
                ),
                nextPage: action.nextPage,
                totalDocuments: action.totalDocuments
            };
            return newState;
        }
        case SET_DOCUMENT_READ: {
            const docs = [...state.documents];
            docs.find(doc => doc.documentId === action.documentRead.documentId).read =
                !!action.documentRead.firstOpenDate;
            return { ...state, documents: docs };
        }
        case SET_UNREAD_DOCUMENTS_PRESENT: {
            return { ...state, unreadDocumentsPresent: action.present };
        }

        default:
            return state;
    }
};
